export default __webpack_public_path__ + "static/media/s4img2.fcc6e421.webp";